<template>
  <div class=" card-section-wrapper">
    <div class="accent-border" :style="`backgroundColor: ${accentColor};`"/>
    <section :class="{'instructional-design-card': true}">
      <div class='card-layout'>
        <div class="img-wrapper">
          <img
            alt=""
            :src="imgSrc"
            class="card-img">
        </div>
        <h3 class="card-heading">
          <template v-if="effectsVisibility && header.line1.includes('Present Levels')">
            <span><span class="heading-light">Identify </span><span class="heading-heavy">Present Levels &</span></span>
            <span class="heading-heavy">Effect Statements</span>
          </template>
          <template v-else>
            <span class="heading-light">{{ header.line1 }}</span>
            <span class="heading-heavy">{{ header.line2 }}<slot name="header-button" /></span>
          </template>
        </h3>
        <p class="card-description">{{ cardDescription }}</p>
        <a
          v-if="btn.external"
          class="btn-a"
          :href="btn.link">
          <button
            class="btn btn-success btn-lg btn-block"
            :style="`backgroundColor: ${buttonColor};`"
            @mouseover="changeColor"
            @mouseout="resetColor"
            tabindex="-1"
          >
            {{ btn.text }} &nbsp;
            <i class="fa fa-chevron-right" />
          </button>
        </a>
        <router-link
          v-else
          class="btn-a"
          :to="{name: `${btn.link}`, query: btn.query}">
          <button
            class="btn btn-success btn-lg btn-block"
            :style="`backgroundColor: ${buttonColor};`"
            @mouseover="changeColor"
            @mouseout="resetColor"
            tabindex="-1"
          >
            {{ btn.text }} &nbsp;
            <i class="fa fa-chevron-right" />
          </button>
        </router-link>
        <div class='other-links-wrapper'>
          <ul class="other-links" :class="{'beta': betaVisibility}">
            <li
              v-for="(link) in otherLinksDisplay"
              :key="link.link"
              :style="`color: ${accentColor}`">
              <a
                :href="link.link"
                :style="`color: ${accentColor}`"
                v-if="link.external">{{ link.text }}</a>
              <router-link
                v-else
                :to="{name: link.link, query: link.query}"
                :style="`color: ${accentColor}`">
                {{ link.text }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

    export default {
        name: 'Home',
        props: {
            accentColor: {
                type: String,
                required: true
            },
            hoverColor: {
                type: String,
                required: true
            },
            imgSrc: {
                type: String,
                required: true
            },
            header: {
                type: Object,
                required: true
            },
            cardDescription: {
                type: String,
                required: true
            },
            btn: {
                type: Object,
                required: true
            },
            otherLinks: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                buttonColor: this.accentColor
            }
        },
        computed: {
          ...mapGetters('visibility', ['betaVisibility', 'iodVisibility', 'effectsVisibility']),
          otherLinksDisplay() {
            return this.otherLinks.filter(link => this.shouldShowLink(link))
          }
        },
        methods: {
            changeColor() {
                this.buttonColor = this.hoverColor;
            },
            resetColor() {
                this.buttonColor = this.accentColor;
            },
            shouldShowLink(link) {
                if (link.betaOnly && !this.betaVisibility) {
                  return false
                }
                if (link.betaHide && this.betaVisibility) {
                  return false
                }
                if (link.hideForNoIod && !this.iodVisibility) {
                  return false
                }
                return true
            }
        },
    }
</script>

<style lang="less" scoped>
@import '~@/variables.less';

.instructional-design-card {
    height: 100%;
    border: 2px solid #BDBDBD;
    border-top: none;

    &.beta{
      flex-direction: column;
      align-items: center;
      & > li {
        list-style-type: none;
        line-height: 2rem;
      }
    }
}
.accent-border {
  height: 7px;
  width: 100%;
}
.img-wrapper {
    height: 161px;
    width: 265px;
    padding: 20px 0 0 0;
    margin: 0 0 0 4rem;
}
.card-img {
    max-width: 100%;
    max-height: 100%;
    height: 161px;
    width: 265px;
}
.card-layout {
    margin: 0 1.5rem;
}
.other-links-wrapper {
    display: flex;
    justify-content: center;
}
.other-links {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 1rem;
    padding-left: 0px;
    flex-direction: column;

    & > li {
      list-style-type: disc;
      line-height: 2rem;

        & > a > span {
          margin-right: 0.25rem;
        }
    }

    & > a:focus {
      outline: 2px solid lighten(@link-color, 20%);;
      outline-offset: 3px;
    }
}
.card-heading {
    display: flex;
    flex-direction: column;
}
.heading-light {
    font-weight: @font-weight-400;
    margin-bottom: 0;
}
.heading-heavy {
  display: flex;
  align-items: center;
    font-weight: @font-weight-700;
    margin-top: 10px;
    height: 1.9rem;
}
.card-description {
    line-height: 1.25rem;
}
.btn-a {
    color: #fff;
    text-decoration: none;
}
.btn-lg {
    border: none;
    box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.2);
    margin: 2rem 0 1.5rem;
    font-weight: @font-weight-700;
    font-size: 1.25rem;
 }
.fa.fa-chevron-right {
    font-size: 1rem;
}
.link-pipe {
    margin: 0 1rem;
}
@media (max-width: @screen-lg) { //1200
    .img-wrapper {
        display: flex;
        justify-content: center;
    }
}
@media (max-width: @screen-md) { // 992
    .card-description {
        font-size: 1rem;
    }
    .btn-lg {
        margin: 1.5rem 0 1.5rem;
    }
    .img-wrapper {
        margin-left: 0;
        width: auto;
    }

}
@media (max-width: @screen-sm) { //768
    .img-wrapper {
        height: 20px;
    }

    .heading-light {
        margin-top: 0;
    }
    .btn-lg {
        margin: 1.5rem 0 1rem;
    }
    .card-img {
        display: none;
    }
}
@media (max-width: @screen-xs) { //480
    .card-layout {
        margin: 0 2rem;
    }
    .card-heading {
        margin-top: 0;
    }
}
</style>
